import { iosStoreUrl, androidStoreUrl } from '@/constants/app'

export const storeButtons = [
	{
		key: 'ios',
		url: iosStoreUrl,
		name: 'iOS app',
		icon: 'Apple',
		qrSrc: '/assets/img/app/qr-ios.png',
	},
	{
		key: 'android',
		url: androidStoreUrl,
		name: 'Android app',
		icon: 'GooglePlay',
		qrSrc: '/assets/img/app/qr-android.png',
	},
]

export const features = [
	{
		key: 'quotes',
		imgSrc: '/assets/img/app/features/quotes.webp',
		title: 'Get quotes',
		description: 'Schedule flights with instant cost and flight time estimates.',
	},
	{
		key: 'manage',
		imgSrc: '/assets/img/app/features/manage.webp',
		title: 'Manage flights',
		description: 'Review and modify your upcoming flights.',
	},
	{
		key: 'monitor',
		imgSrc: '/assets/img/app/features/monitor.webp',
		title: 'Monitor flights',
		description: 'Stay informed on your past trips and track your hours.',
	},
	{
		key: 'share',
		imgSrc: '/assets/img/app/features/share.webp',
		title: 'Share flights',
		description: 'List your flights for sharing and access shared flights from others quickly and flexibly.',
		new: true,
	},
]

export const sharingFaq = [
	{
		question: "What is the Flight Sharing feature?",
		answer: "Flight Sharing is an exclusive Jetfly App feature that allows co-owners to share available seats on their private flights with other Jetfly owners. This feature enhances flexibility, improves aircraft efficiency, and helps reduce environmental impact.",
	},
	{
		question: "Who can use the Flight Sharing feature?",
		answer: "Flight Sharing is available exclusively to Jetfly co-owners participating in our fractional aircraft ownership program.",
	},
	{
		question: "How does Flight Sharing benefit Jetfly owners?",
		answer: "Flight Sharing allows owners to make the most of their flights by offering unoccupied seats to other co-owners. This optimizes aircraft usage, reduces emissions per passenger, and lowers overall costs—creating a more efficient and flexible ownership experience.",
	},
	{
		question: "Can I choose whether or not to share my flights?",
		answer: "Yes, Jetfly owners have complete control over their sharing preferences. You can choose to always share available seats, decide on a flight-by-flight basis, or keep all flights private.",
	},
	{
		question: "How can I book a seat on a shared flight?",
		answer: "Jetfly owners can view and book available shared flights offered by other co-owners directly through the Jetfly App. This process is designed to be seamless and flexible, giving owners more travel options.",
	},
	{
		question: "Is Flight Sharing mandatory for all owners?",
		answer: "No, Flight Sharing is entirely optional. Owners can decide whether to participate and how they would like to share their flights.",
	},
	{
		question: "How does Flight Sharing contribute to sustainability?",
		answer: "By maximizing seat occupancy, Flight Sharing reduces the number of empty seats on flights, lowering carbon emissions per passenger and improving the overall environmental efficiency of each flight.",
	},
	{
		question: "Can owners change their sharing preferences at any time?",
		answer: "Yes, Jetfly owners can update their sharing preferences at any time in the Jetfly App, giving them full control over how and when they share seats on their flights.",
	},
	{
		question: "Who can I contact for more information about Jetfly and Flight Sharing?",
		answer: "For more information about Jetfly’s services or the Flight Sharing feature, please contact our <a href=\"mailto:operations@jetfly.com\">Reservations Team</a> or visit our website.",
	},
]
